import { products, Product } from "@/data/products";

/**
 * Find a product by exact name match
 * @param name - The exact product name to search for
 * @returns The matching product or undefined
 */
export function getProductByName(name: string): Product | undefined {
  return products.find(p => p.name.toLowerCase() === name.toLowerCase());
}

/**
 * Get product image with fallback
 * @param name - The product name
 * @returns Image object with src and alt, or placeholder
 */
export function getProductImage(name: string): { src: string; alt: string } {
  const product = getProductByName(name);
  
  if (product?.image) {
    return product.image;
  }
  
  // Fallback placeholder
  return {
    src: "/images/placeholder.png",
    alt: `${name} - Product image coming soon`
  };
}

/**
 * Get product description with fallback
 * @param name - The product name
 * @returns Product description or placeholder
 */
export function getProductDescription(name: string): string {
  const product = getProductByName(name);
  return product?.description || "Description coming soon";
}

/**
 * Get product price
 * @param name - The product name
 * @returns Product price or 0
 */
export function getProductPrice(name: string): number {
  const product = getProductByName(name);
  return product?.price || 0;
}
